import { DatePicker } from '@mui/lab';
import { Grid } from '@mui/material';
import { memo, useCallback } from 'react';
import { PmiTextField } from 'shell/components/shared/text-field';
import { FormikErrors, FormikTouched } from 'formik';
import { SectionVM } from 'civil-status/view-models/step-form';
import Italian from '../../shared/italian';
import { ItalianForm } from 'shell/view-models/italian-form';

interface ActConsentProps {
  disabled?: boolean;
  values?: SectionVM;
  errors?: FormikErrors<SectionVM>;
  touched?: FormikTouched<SectionVM>;
  onChange: (key: keyof SectionVM, value: SectionVM[keyof SectionVM]) => void;
  configuration?: string;
}

const RecognitionBeforBirthActComponent = ({
  disabled = false,
  values,
  errors,
  touched,
  onChange,
}: ActConsentProps): React.ReactElement => {
  const onChangeItalian = useCallback(
    (key, value) => {
      onChange('italian', {
        ...(values || {}).italian,
        [key]: value,
      });
    },
    [values, onChange]
  );

  const onChangesItalian = useCallback(
    (valuesNew) => {
      onChange('italian', {
        ...(values || {}).italian,
        ...valuesNew,
      });
    },
    [values, onChange]
  );

  return (
    <Grid container spacing={1} item xs={12}>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Data formazione documento *"
          aria-label="Data formazione documento"
          value={values?.documentDateFormation || null}
          onChange={(date) => {
            onChange('documentDateFormation', date);
          }}
          disabled={disabled}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="documentDateFormation"
              fullWidth
              helperText={errors?.documentDateFormation}
              error={touched?.documentDateFormation && Boolean(errors?.documentDateFormation)}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          label="Estremi documento *"
          aria-label="Estremi documento "
          id="documentExtremes"
          name="documentExtremes"
          fullWidth
          disabled={disabled}
          helperText={errors?.documentExtremes}
          error={touched?.documentExtremes && Boolean(errors?.documentExtremes)}
          type="text"
          variant="outlined"
          value={values?.documentExtremes || ''}
          onChange={(event) => {
            onChange('documentExtremes', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          label="Nome ente *"
          aria-label="Nome ente"
          id="nameInstitution"
          name="nameInstitution"
          fullWidth
          disabled={disabled}
          helperText={errors?.nameInstitution}
          error={touched?.nameInstitution && Boolean(errors?.nameInstitution)}
          type="text"
          variant="outlined"
          value={values?.nameInstitution || ''}
          onChange={(event) => {
            onChange('nameInstitution', event.target.value);
          }}
        />
      </Grid>
      <Italian
        disabledComponent={disabled}
        values={values?.italian}
        onChange={onChangeItalian}
        onChanges={onChangesItalian}
        errors={errors?.italian as FormikErrors<ItalianForm>}
        touched={touched?.italian as unknown as FormikTouched<ItalianForm>}
        labelMunicipality="Comune ente"
        labelProvince="Provincia ente"
        fromDate={values?.documentDateFormation || null}
        required
      />
    </Grid>
  );
};

RecognitionBeforBirthActComponent.displayName = 'Form Recognition Befor Birth Act component';

const RecognitionBeforBirthAct = memo(RecognitionBeforBirthActComponent);

export default RecognitionBeforBirthAct;
